import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EcacDepartureSummaryReportService from '_services/ecac-departure-summary-report-service';

export const fetchEcacDepartureSummaryReport = createAsyncThunk(
    'ecacDepartureSummaryReport/fetch',
    async (params, { signal }) => {
        return await EcacDepartureSummaryReportService.getEcacDepartureSummaryReport(params, signal);
    }
);

export const patchBookings = createAsyncThunk(
    'ecacDepartureSummaryReport/patchBookings',
    async ({ bookingIds, patch }) => {
        await Promise.all(
            bookingIds.map((bookingId) => EcacDepartureSummaryReportService.patchBooking(bookingId, patch))
        );
        return { bookingIds, patch };
    }
);

const initialState = {
    data: null,
    status: 'idle',
    error: null,
    patchStatus: 'idle',
    patchError: null,
};

const ecacDepartureSummaryReportSlice = createSlice({
    name: 'ecacDepartureSummaryReport',
    initialState,
    reducers: {
        resetEcacDepartureSummaryReport: (state) => {
            state.data = null;
            state.status = 'idle';
            state.error = null;
        },
        resetPatchBookingStatus: (state) => {
            state.patchStatus = 'idle';
            state.patchError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEcacDepartureSummaryReport.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchEcacDepartureSummaryReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
                state.error = null;
            })
            .addCase(fetchEcacDepartureSummaryReport.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(patchBookings.pending, (state) => {
                state.patchStatus = 'loading';
                state.patchError = null;
            })
            .addCase(patchBookings.fulfilled, (state) => {
                state.patchStatus = 'succeeded';
                state.patchError = null;
            })
            .addCase(patchBookings.rejected, (state, action) => {
                state.patchStatus = 'failed';
                state.patchError = action.error.message;
            });
    },
});

export const selectEcacDepartureSummaryReportData = (state) => state.ecacDepartureSummaryReport.data;
export const selectEcacDepartureSummaryReportStatus = (state) => state.ecacDepartureSummaryReport.status;
export const selectEcacDepartureSummaryReportError = (state) => state.ecacDepartureSummaryReport.error;
export const selectPatchBookingStatus = (state) => state.ecacDepartureSummaryReport.patchStatus;

export const { resetEcacDepartureSummaryReport, resetPatchBookingStatus } = ecacDepartureSummaryReportSlice.actions;

export default ecacDepartureSummaryReportSlice.reducer;
